function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.89865 12.7939V14.5833C9.89865 14.8595 10.1225 15.0833 10.3986 15.0833H12.5M9.89865 7.47133V5.5M10.121 12.7939H9.87903C8.06936 12.7939 6.25 11.9715 6.25 10.1326C6.25 8.29369 8.07661 7.47133 9.87903 7.47133H10.121C11.9258 7.47133 13.75 8.29369 13.75 10.1326C13.75 11.9715 11.9282 12.7939 10.121 12.7939Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.99984,
  cy: 10.4998,
  r: 8.33333,
  stroke: "currentColor"
});
function SvgCoinThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.17 1.67 17.67 17.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinThick);
export default __webpack_public_path__ + "static/media/coin-thick.cbfe5ef6.svg";
export { ForwardRef as ReactComponent };